/**
 * Extracts the companyId segment from the current URL.
 *
 * Matches both `/hub/:companyId/...` and `/site-id/:siteId/hub/:companyId/...`.
 * Returns 'stepstone' when running server-side or when the URL does not match —
 * every AMA tracking/session call must carry a non-empty companyId.
 */
export const getCompanyIdFromUrl = () => {
    if (typeof window === 'undefined')
        return 'stepstone';
    const pathMatch = window.location.pathname.match(/\/hub\/([^/]+)/);
    return pathMatch?.[1] || 'stepstone';
};
